import React from 'react';
import PropTypes from 'prop-types';

import RichText from '../Prismic/RichText';
import Button from 'wonderbly-components/lib/Button';

import cx from 'classnames';

import './CookieConsent.scss';

const CookieConsent = props => (
  <div className={cx('cookie-consent', {
    hidden: !props.hasMounted
  })}>
    <div className="container-guttered">
      <div className="cookie-consent-wrapper">
        <RichText className="cookie-consent-description" fields={props.cookieConsent.description} />
        <div className="cookie-consent-button-wrapper">
          <Button onClick={props.handleClose} colour="almost-light">{props.cookieConsent.cta}</Button>
        </div>
      </div>
    </div>
  </div>
);

CookieConsent.propTypes = {
  cookieConsent: PropTypes.shape({
    description: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
    cta: PropTypes.string.isRequired,
  }).isRequired,
  handleClose: PropTypes.func.isRequired,
  hasMounted: PropTypes.bool.isRequired,
};

export default CookieConsent;



// WEBPACK FOOTER //
// ./src/client/js/view/components/CookieConsent/CookieConsent.js